const frTranslation = {
  common: {
    welcome: 'Bienvenue',
    login: 'Connexion',
    logout: 'Déconnexion',
    send: 'Envoyer',
    retry: 'Réessayer',
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    cancel: 'Annuler',
    save: 'Enregistrer',
    language: 'Langue',
    newChat: 'Nouvelle conversation',
    startingNewChat: "Démarrage d'une nouvelle conversation...",
    searchMessage: 'Réflexion et analyse des informations pertinentes...',
    searchMessageTiming: 'Recherche dans les instructions de travail et les éléments de connaissance...',
    tryAgain: 'Réessayer',
    back: 'Retour',
    goBack: 'Revenir',
    attachDocument: 'Joindre un document',
    aiDisclaimer:
      "Les réponses sont générées par l'IA. Vérifiez toujours les informations importantes via des sources officielles.",
    copyAnswer: 'Copier la réponse',
    copyMessage: 'Copier le message',
    copied: 'Copié !',
    copyToClipboard: 'Copier dans le presse-papiers',
    expand: 'Développer',
    minimize: 'Minimiser',
    showMore: 'Voir plus',
    noInternalKnowledge: 'Aucune connaissance interne trouvée',
    noAdditionalResponse: 'Pas de réponse supplémentaire',
    swapMessage:
      "Nous avons trouvé une réponse spécifique à l'entreprise. La réponse générale est toujours disponible ci-dessous.",
    toggleShowGeneral: 'Afficher la réponse générale (ChatGPT)',
    toggleHideGeneral: 'Masquer la réponse générale',
    progressExternal: 'Recherche avec ChatGPT…',
    progressInternal: 'Recherche dans la base interne…',
    internalError: 'Connaissances internes actuellement indisponibles.',
    promoteSecondary: 'Utiliser comme réponse principale',
    compareAnswers: 'Comparer les réponses côte à côte',
    switchBack: 'Revenir',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Directives internes',
  },
  knowledge_source: {
    general_info: 'Informations générales',
    internal_guidelines: 'Directives internes',
    internet_results: 'Résultats de recherche internet',
  },
  errors: {
    assistantResponseContentViolation:
      "La réponse de l'assistant enfreint notre politique de contenu. Veuillez réessayer ou reformuler votre question.",
    userInputContentViolation:
      'Votre demande contient du contenu qui enfreint notre politique. Veuillez reformuler votre question.',
    llmProviderUserInputBlocked:
      "Votre message a été bloqué par le filtre de contenu du fournisseur d'IA. Veuillez reformuler votre question.",
    llmProviderBotResponseBlocked:
      "La réponse de l'IA a été bloquée par le filtre du fournisseur. Veuillez réessayer ou reformuler votre question.",
    llmProviderApiError: 'Nous rencontrons des problèmes avec notre service IA. Veuillez réessayer plus tard.',
    serverError:
      "Une erreur serveur imprévue s'est produite. Veuillez réessayer ou contacter le support si le problème persiste.",
    agentNotFound: "L'assistant que vous recherchez n'existe pas ou n'est plus disponible.",
    conversationNotFound: "La conversation que vous recherchez n'existe pas ou n'est plus disponible.",
    startViolatedPoliciesList: 'Les politiques suivantes ont été violées',
    questionTooLong: {
      title: 'Votre question est trop longue',
      description: 'La longueur maximale est de 30 000 caractères.',
    },
    excelNotSupportedYet: {
      title: 'Le support Excel et CSV arrive bientôt !',
      description:
        "Nous travaillons sur la prise en charge des fichiers Excel et CSV qui sera bientôt disponible. Veuillez utiliser pour l'instant des fichiers PDF ou Word.",
    },
  },
  auth: {
    welcomeTester: 'Bienvenue collègue',
    welcomeMessage: 'Bienvenue sur Cody !',
    loginWithMicrosoft: 'Se connecter avec Microsoft',
    loginInstructions: 'Connectez-vous avec votre compte Microsoft pour commencer.',
  },
  chat: {
    placeholder: 'Posez votre question ici',
    thinking: 'Réflexion...',
    anonymousUser: 'Anonyme',
    howToAskGoodQuestion: 'Comment poser une bonne question ?',
    askQuestion: 'Posez votre question',
    exampleQuestions: 'Exemples de questions',
    tryAsking: 'Essayez de demander :',
    assistant: 'Cody, votre assistant digital Timing',
    welcomeMessage:
      "Bonjour {{name}} ! Je suis Cody, votre assistant Timing digital. Je peux vous aider pour les questions sur l'inflow, la rétention et/ou l'outflow à partir des instructions de travail et des éléments de connaissance. Que voulez-vous savoir ?",
    loading: 'Chargement de la conversation...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    sensitiveInformationWarning: 'Attention : sujet sensible, vérification supplémentaire nécessaire.',
    serverError:
      "Une erreur serveur imprévue s'est produite. Veuillez réessayer ou contacter le support si le problème persiste.",
    disclaimerText:
      "Les réponses sont recherchées dans Sharepoint et générées par l'IA. Vérifiez les sources pour les sujets importants.",
  },
  internetSearch: {
    badgeLabel: 'Recherche internet activée',
    badgeTooltip: 'Cet assistant peut utiliser Internet pour rechercher',
    inlineWarning:
      "Remarque : ne partagez pas de données sensibles ou personnelles. Les entrées pour la recherche internet peuvent être utilisées par Microsoft pour l'entraînement.",
    dismiss: 'Compris',
    modalTitle: 'Attention aux données sensibles',
    modalBody:
      'Cet assistant utilise des recherches internet. Ne partagez pas de données sensibles ou personnelles. Les entrées peuvent être traitées par Microsoft et utilisées pour entraîner des modèles. Partagez uniquement ce qui est nécessaire et suivez les politiques Timing.',
    gotIt: 'Compris',
  },
  agentChat: {
    placeholder: "Saisissez votre question pour l'agent...",
    welcomeMessage: "Bonjour, je suis votre agent IA. Comment puis-je vous aider aujourd'hui ?",
    privilegedWelcomeMessage: 'Bonjour {{userName}} ! {{description}}',
    startPrompt: 'Posez une question pour commencer',
  },
  profile: {
    settings: 'Paramètres',
    selectLanguage: 'Sélectionnez votre langue',
    appearance: 'Apparence',
    darkMode: 'Mode sombre',
    languageChanged: 'Langue modifiée',
    noEmailAvailable: 'Aucun e-mail disponible',
  },
  sidebar: {
    conversations: 'Historique',
    assistants: 'Assistants',
    info: 'Info',
    chatHistory: 'Historique des conversations',
    today: "Aujourd'hui",
    thisWeek: 'Cette semaine',
    lastWeek: 'La semaine dernière',
    earlier: 'Plus tôt',
    conversation: 'Conversation',
    noAssistantsAvailable: 'Aucun assistant disponible',
    noContent: 'Pas de contenu',
    noPreviousConversations: 'Aucun historique précédent trouvé',
    searchConversations: "Rechercher dans l'historique...",
    noSearchResults: 'Aucun historique correspondant à votre recherche',
    aboutCody: 'Cody, votre assistant digital',
    aboutCodyDescription: 'Cody vous aide à rendre votre travail plus agréable et plus simple.',
    dataVisibilityNoticeTitle: 'Avis de visibilité des données',
    dataVisibilityNoticeBody:
      "Cher utilisateur, lorsque vous activez Cody, les administrateurs peuvent avoir accès au contenu – y compris les informations factuelles – que vous partagez. Naturellement, les collègues et les tiers n'ont pas accès aux données et questions que vous soumettez.",
    bewareDoNotSharePersonalInformation: "Remarque : ne partagez pas d'informations personnelles.",
    codyKnowledge:
      "Cody connaît toutes les informations Timing disponibles sur TIPP. Ce sont tous les éléments de connaissance et instructions de travail sur l'inflow, la rétention et l'outflow.",
    codyGeneralQuestions:
      'Cody peut aussi vous aider pour des questions générales que vous pouvez poser à ChatGPT ou trouver sur internet.',
    noPersonalQuestions: 'Cody ne peut pas répondre aux questions spécifiques aux clients ou intérimaires.',
    noInTimeQuestions:
      "Cody ne peut pas répondre aux questions sur les informations d'Intime, comme les actualités.",
    askClearQuestions: "Posez une question claire à Cody pour qu'il puisse bien vous aider.",
    conversationHistory:
      "Cody tient compte de votre historique de conversation. Si vous voulez poser une question de suivi, c'est possible.",
    startNewConversation:
      "Si vous posez une question sur un autre sujet, il est préférable de cliquer sur 'nouvelle conversation'",
    seeHowToAsk: 'voir : <1>Comment poser une bonne question ?</1> pour plus de conseils',
    aboutAssistants: 'Assistant',
    whereToFindAssistants: 'Allez à la bibliothèque pour un aperçu des assistants.',
    favorites: 'Favoris',
    noFavorites: 'Aucun favori',
    addFavoritesHint: 'Allez à la bibliothèque pour ajouter des assistants à vos favoris.',
    whenToUseAssistants:
      "Utilisez le 'Guide through Cody' > cela vous aide à déterminer ce que Cody peut faire pour vous.",
    BewareAssistantsNotAgents:
      "Remarque : Cody a des assistants, pas des agents. En bref : Cody vous aide pour des tâches ponctuelles lorsque vous le demandez, comme résumer un e-mail. Il n'enverra pas automatiquement l'e-mail pour vous.",
    feedback:
      'Utilisez les pouces sous la réponse pour donner votre avis. Cela aide à rendre Cody plus intelligent !',
    technicalIssuesTitle: "Problèmes techniques ou suggestion d'amélioration ?",
    technicalIssueLogIn: "Vous ne pouvez pas vous connecter ou vous recevez un message d'erreur ?",
    technicalIssueImprovementProposal: "Avez-vous une suggestion d'amélioration générale pour Cody ?",
    technicalISsueAssistants:
      "Avez-vous une suggestion d'amélioration pour un des assistants ou souhaitez-vous en demander un nouveau ?",
    technicalIssueBeta: 'Veuillez le signaler dans le chat Teams Cody des testeurs bêta',
    technicalIssueNonBeta: 'Signalez-le en créant un ticket dans <1>SSD</1>',
    loadingPrivilegedAgents: 'Chargement de Cody...',
  },
  feedback: {
    likeAnswer: "J'aime la réponse",
    dislikeAnswer: "Je n'aime pas la réponse",
    feedbackSent: 'Votre avis a été envoyé ! ✅',
    provideFeedback: 'Donner un retour sur la question',
    enterFeedback: 'Saisissez votre retour ici',
    send: 'Envoyer',
    reasons: {
      incorrect: 'La réponse est incorrecte',
      sourceIncorrect: 'La source est incorrecte',
      other: 'Autre...',
    },
  },
  instructionModal: {
    title: 'Comment poser une bonne question ?',
    example: 'Exemple',
  },
  instructions: {
    steps: {
      useFullSentences: {
        title: 'Utilisez des phrases complètes',
        description:
          "Essayez d'utiliser une phrase complète pour éviter les malentendus et obtenir immédiatement la meilleure réponse possible.",
        examples: ['"Comment créer un rendez-vous tarifaire" au lieu de "rendez-vous tarifaire".'],
      },
      noSpecificQuestions: {
        title: 'Ne posez pas de questions spécifiques au client/intérimaire',
        description:
          "Cody ne connaît que les instructions de travail et éléments de connaissance sur TIPP, pas les informations spécifiques au client ou à l'intérimaire ni d'autres informations absentes de TIPP.",
        examples: [
          'Ne demandez pas : "Combien de jours de congé reste-t-il à John Doe ?", mais plutôt "Où puis-je voir combien de jours de congé il reste à mon intérimaire ?"',
        ],
      },
      askOneThingAtATime: {
        title: 'Demandez une chose à la fois',
        description:
          'Posez une seule question à la fois. Cela aide le chatbot à fournir des réponses ciblées et précises.',
        examples: [
          'Ne demandez pas "Combien d\'heures un intérimaire peut-il travailler par semaine et quand un quart est-il considéré comme de nuit ?", mais posez ces deux questions séparément.',
        ],
      },
    },
    aiAssistant: {
      title: 'Votre assistant IA dans Teams',
      description:
        "Cody est un assistant alimenté par l'IA qui vous aide avec vos connaissances. Cody vous aide à rédiger des e-mails, messages, offres d'emploi, présentations, résumés, traductions et plus encore.",
      tipTitle: "Vous utilisez Cody AI (Teams) ? Alors gardez les points suivants à l'esprit :",
      bullets: [
        'Ne partagez jamais de données personnelles comme des noms et adresses',
        "Ne partagez jamais d'informations confidentielles, par exemple sur des clients ou des transactions",
        'Vérifiez toujours les sources utilisées par Cody',
        'Ne créez pas de contenu sensible pour Timing, comme pour les investisseurs ou les employés',
      ],
      flow: {
        title: 'Comment fonctionne le chatbot ?',
        description:
          "Cody répond à votre question sur la base des informations dont il dispose, la base de connaissances spécifique Timing (TIPP). Cody peut également répondre sur la base d'informations issues d'un outil d'entraînement comme ChatGPT.",
      },
      funFact: {
        title: 'Fun Fact : comment fonctionne Cody',
        description:
          "Cody (LLM) est une application autonome, pas le vrai ChatGPT. Elle est composée de plusieurs composants et d'un modèle RAG informé par le contenu de TIPP qui est recherché à chaque question.",
      },
    },
    chat: {
      title: 'Discuter avec Cody',
      description: "Pour obtenir la meilleure réponse, réfléchissez d'abord à ce que vous voulez savoir.",
      steps: [
        {
          title: 'Soyez précis',
          description:
            'Il est préférable de demander "Comment demander des vacances pour mon intérimaire ?" plutôt que "questions vacances".',
        },
        {
          title: 'Décrivez le contexte',
          description:
            'La réponse sera meilleure si Cody comprend les détails. Quel rôle jouez-vous ? Que voulez-vous accomplir?',
        },
        {
          title: "Partagez suffisamment d'informations",
          description: "N'oubliez pas de partager des exemples pertinents, contraintes et détails de contexte.",
        },
        {
          title: 'Vérifiez la réponse',
          description: "Si quelque chose n'est pas clair ou incorrect, posez une question de suivi.",
        },
      ],
    },
    examples: {
      title: 'Exemples de questions',
      subtitle: 'Voici quelques exemples de demandes pour vous aider à démarrer',
      items: [
        "Je reçois un message d'erreur lorsque je me connecte à Intime. Que dois-je faire ?",
        'Comment puis-je ajouter des actualités à la bibliothèque ?',
        "Aidez-moi ! J'ai soumis par erreur un mauvais enregistrement de pointage.",
        "Mon collègue/intérimaire souhaite accéder au chatbot. Comment puis-je l'activer ?",
        "Quelles sont les étapes clés lors de l'intégration d'un employé externe ?",
      ],
    },
  },
  conversations: {
    noAssistantsMessage: "On dirait qu'aucune bibliothèque n'est configurée. Veuillez contacter le support.",
    searchPlaceholder: 'Rechercher des conversations',
    newChat: 'Nouvelle conversation',
    untitledConversation: 'Conversation sans titre',
    emptyStateTitle: 'Aucune conversation',
    emptyStateDescription: "Vous n'avez pas encore de conversations.",
    delete: 'Supprimer',
    share: 'Partager',
    rename: 'Renommer',
    copyLink: 'Copier le lien',
    copiedLink: 'Lien de conversation copié !',
    deleteWarning: 'Êtes-vous sûr ? Ce chat sera définitivement supprimé.',
    deleteFailed: 'Échec de la suppression du chat',
    deleteSuccess: 'Chat supprimé',
  },
  homePage: {
    title: 'Discuter avec Cody',
    subtitle:
      "Cody est un chatbot spécialisé dans les connaissances Timing sur l'inflow, la rétention et l'outflow.",
    newChat: 'Nouvelle conversation',
    search: 'Rechercher',
    feedback: 'Retour',
    seeExamples: 'Voir des exemples',
    featuredTopics: 'Sujets en vedette',
    startWithTopic: 'Commencer avec un sujet',
    appFeatures: "Fonctionnalités de l'application",
    libraryInformation: 'Informations de la bibliothèque',
  },
  search: {
    noResults: 'Aucun résultat trouvé',
    tryDifferentQuery: 'Essayez une autre requête ou recherchez un autre mot clé',
  },
  share: {
    inviteColleagues: 'Invitez vos collègues à essayer Cody',
    and: 'et',
    shareConversations: 'Partagez vos conversations avec les autres',
    sharePublic: 'Partager avec un lien',
    shareTeams: 'Partager dans Teams',
    shareCopy: 'Copier',
    shared: 'Partagé',
  },
  profilePage: {
    personalInformation: 'Informations personnelles',
    fullName: 'Nom complet',
    email: 'E-mail',
    accountId: 'ID du compte',
    role: 'Rôle',
    language: 'Langue',
    memberSince: 'Membre depuis',
  },
  assistantLibrary: {
    title: "Bibliothèque d'assistants",
    subtitle: 'Choisissez un assistant pour commencer',
    searchPlaceholder: 'Rechercher des assistants...',
    category: 'Catégorie',
    allCategories: 'Toutes les catégories',
    sortBy: 'Trier par',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    name: 'Nom',
    description: 'Description',
    mostPopular: 'Les plus populaires',
    myFavorites: 'Mes favoris',
    results: 'Résultats',
    result: 'Résultat',
    noResultsFound: 'Aucun assistant trouvé',
    assistantCard: {
      created: 'Créé',
      updated: 'Mis à jour',
      cta: 'Commencer le chat',
    },
    filters: {
      reset: 'Réinitialiser',
      showFilters: 'Afficher les filtres',
      hideFilters: 'Masquer les filtres',
    },
  },
  libraryBanner: {
    title: "Bienvenue dans la bibliothèque d'assistants",
    description:
      "Vous trouverez ici des assistants spécialisés pour différents besoins, notamment la conformité RH, le support technique, la formation des utilisateurs, l'analyse de données et plus encore.",
    readyToChat: 'Prêt à discuter ?',
    browseAssistants: 'Parcourir les assistants',
  },
  assistant: {
    welcomeTitle: 'Bienvenue chez {{name}}',
    welcomeMessage:
      "Saisissez votre question ou sélectionnez l'une des questions exemples ci-dessous pour commencer.",
    conversations: 'Conversations',
    settings: 'Paramètres',
    description: 'Description',
    noDescription: 'Aucune description disponible',
    exampleQuestions: 'Questions exemples',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    createdBy: 'Créé par',
    timezone: 'Fuseau horaire',
    language: 'Langue',
    public: 'Public',
    private: 'Privé',
    knowledgeSource: 'Source de connaissance',
    noKnowledgeSource: 'Aucune source de connaissance fournie',
    chat: 'Chat',
    prompts: 'Prompts',
    files: 'Fichiers',
    instructions: 'Instructions',
    loading: "Chargement de l'assistant...",
    loadFailed: "Impossible de charger l'assistant",
    retry: 'Réessayer',
    startChat: 'Commencer le chat',
    startNewChat: 'Commencer un nouveau chat',
    inputPlaceholder: 'Saisissez votre message...',
    uploadFile: 'Téléverser un fichier',
    fileUploaded: 'Fichier téléversé',
    fileRemoved: 'Fichier supprimé',
    fileUploadError: 'Erreur lors du téléversement du fichier',
    fileRemoveError: 'Erreur lors de la suppression du fichier',
    fileTooLarge: 'Fichier trop volumineux',
    fileTooLargeDescription: 'La taille maximale du fichier est de 10 Mo',
    fileTypeNotAllowed: 'Type de fichier non autorisé',
    fileTypeNotAllowedDescription: 'Types de fichiers autorisés : PDF, DOCX, TXT',
    send: 'Envoyer',
    sending: 'Envoi...',
    messageSent: 'Message envoyé',
    messageFailed: "Échec de l'envoi du message",
    newMessage: 'Nouveau message',
    clearChat: 'Effacer le chat',
    confirmClearChat: 'Êtes-vous sûr de vouloir effacer le chat ? Cette action ne peut pas être annulée.',
    chatCleared: 'Chat effacé',
    chatClearFailed: "Échec de l'effacement du chat",
    copyConversation: 'Copier la conversation',
    conversationCopied: 'Conversation copiée',
    copyFailed: 'Échec de la copie',
    feedback: 'Retour',
    submitFeedback: 'Envoyer le retour',
    feedbackSent: 'Retour envoyé',
    feedbackFailed: "Échec de l'envoi du retour",
    feedbackPlaceholder: "Comment s'est passée votre expérience ?",
    ratingRequired: 'Veuillez sélectionner une note',
    optional: 'Facultatif',
    required: 'Obligatoire',
  },
  assistantSettings: {
    title: "Paramètres de l'assistant",
    description: 'Ajustez la configuration de votre assistant',
    tabs: {
      general: 'Général',
      permissions: 'Autorisations',
      knowledge: 'Connaissance',
      behavior: 'Comportement',
    },
    save: 'Enregistrer les paramètres',
    saved: 'Paramètres enregistrés',
    saveError: "Erreur lors de l'enregistrement des paramètres",
  },
  assistantGeneral: {
    title: 'Paramètres généraux',
    name: 'Nom',
    description: 'Description',
    timezone: 'Fuseau horaire',
    language: 'Langue',
    visibility: 'Visibilité',
    public: 'Public',
    private: 'Privé',
    save: 'Enregistrer',
    saved: 'Enregistré',
    saveError: "Erreur lors de l'enregistrement",
  },
  assistantPermissions: {
    title: 'Autorisations',
    addUser: 'Ajouter un utilisateur',
    addGroup: 'Ajouter un groupe',
    searchUsers: 'Rechercher des utilisateurs',
    searchGroups: 'Rechercher des groupes',
    invite: 'Inviter',
    invited: 'Invité',
    inviteError: "Erreur lors de l'invitation",
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
    access: 'Accès',
    accessLevels: {
      owner: 'Propriétaire',
      editor: 'Éditeur',
      viewer: 'Lecteur',
    },
  },
  assistantKnowledge: {
    title: 'Source de connaissance',
    addSource: 'Ajouter une source',
    searchSources: 'Rechercher des sources',
    upload: 'Téléverser',
    uploaded: 'Téléversé',
    uploadError: 'Erreur de téléversement',
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
    sourceType: 'Type de source',
    sourceTypes: {
      document: 'Document',
      url: 'URL',
      database: 'Base de données',
    },
  },
  assistantBehavior: {
    title: 'Comportement',
    instructions: 'Instructions',
    addInstruction: 'Ajouter une instruction',
    model: 'Modèle',
    temperature: 'Température',
    maxTokens: 'Nombre max de tokens',
    topP: 'Top P',
    frequencyPenalty: 'Pénalité de fréquence',
    presencePenalty: 'Pénalité de présence',
    reset: 'Réinitialiser',
    resetConfirm: 'Voulez-vous vraiment réinitialiser ce comportement aux valeurs par défaut ?',
    resetSuccess: 'Comportement réinitialisé',
    resetFailed: 'Échec de la réinitialisation',
  },
  promptTemplates: {
    title: 'Modèles de prompt',
    subtitle: 'Créer et gérer des prompts réutilisables',
    create: 'Créer un modèle',
    edit: 'Modifier le modèle',
    delete: 'Supprimer le modèle',
    name: 'Nom',
    description: 'Description',
    content: 'Contenu',
    created: 'Modèle créé',
    updated: 'Modèle mis à jour',
    deleted: 'Modèle supprimé',
    creationError: 'Erreur lors de la création du modèle',
    updateError: 'Erreur lors de la mise à jour du modèle',
    deletionError: 'Erreur lors de la suppression du modèle',
    deleteConfirmTitle: 'Supprimer le modèle',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce modèle ?',
    deleteWarning: 'Cette action ne peut pas être annulée.',
  },
  promptForm: {
    name: 'Nom',
    namePlaceholder: 'Entrez le nom du modèle',
    nameHelp: 'Choisissez un nom descriptif pour votre modèle',
    description: 'Description',
    descriptionPlaceholder: 'Entrez la description du modèle',
    descriptionHelp: 'Bref aperçu du but du modèle',
    content: 'Contenu',
    contentPlaceholder: 'Entrez le contenu du prompt',
    contentHelp: 'Utilisez des variables comme {{name}} et {{context}}',
    save: 'Enregistrer le modèle',
    saving: 'Enregistrement...',
    saved: 'Modèle enregistré',
    saveError: "Erreur lors de l'enregistrement du modèle",
  },
  agentBuilder: {
    back: 'Retour',
    next: 'Suivant',
    saveAsDraft: 'Enregistrer comme brouillon',
    saveAndFinish: 'Enregistrer et terminer',
    launchAssistant: "Lancer l'assistant",
    previous: 'Précédent',
    continue: 'Continuer',
    cancel: 'Annuler',
  },
  createAgent: {
    title: 'Créer un assistant',
    subtitle: 'Configurez votre nouvel assistant IA',
    name: 'Nom',
    description: 'Description',
    language: 'Langue',
    timezone: 'Fuseau horaire',
    visibility: 'Visibilité',
    public: 'Public',
    private: 'Privé',
    next: 'Suivant',
    back: 'Retour',
    create: 'Créer un assistant',
    creating: 'Création...',
    created: 'Assistant créé',
    createError: "Erreur lors de la création de l'assistant",
    required: 'Ce champ est obligatoire',
  },
  agentAppearance: {
    title: 'Apparence',
    subtitle: "Personnalisez l'apparence de votre assistant",
    icon: 'Icône',
    color: 'Couleur',
    iconHelp: 'Choisissez une icône adaptée à votre marque',
    colorHelp: "Choisissez une couleur pour l'interface de l'assistant",
  },
  agentBehavior: {
    title: 'Comportement',
    subtitle: 'Contrôlez la façon dont votre assistant répond',
    systemPrompt: 'Prompt système',
    systemPromptHelp: 'Guidez le ton et la personnalité de votre assistant',
    guardrails: 'Garde-fous',
    guardrailsHelp: 'Définissez ce que votre assistant ne doit pas faire',
    temperature: 'Température',
    maxTokens: 'Nombre max de tokens',
    topP: 'Top P',
    frequencyPenalty: 'Pénalité de fréquence',
    presencePenalty: 'Pénalité de présence',
  },
  agentKnowledge: {
    title: 'Connaissance',
    subtitle: 'Connectez des sources de connaissance à votre assistant',
    uploadFiles: 'Téléverser des fichiers',
    addLinks: 'Ajouter des liens',
    addText: 'Ajouter du texte',
    upload: 'Téléverser',
    uploading: 'Téléversement...',
    uploaded: 'Téléversé',
    uploadError: 'Erreur de téléversement',
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
    maxFiles: "Jusqu'à 10 fichiers",
    maxSize: "Jusqu'à 10 Mo par fichier",
    supportedFormats: 'PDF, DOCX, TXT',
  },
  agentPreview: {
    title: 'Aperçu',
    subtitle: 'Testez votre assistant avant de le lancer',
    welcomeMessage: 'Bienvenue ! Je suis votre nouvel assistant. Comment puis-je aider ?',
    inputPlaceholder: 'Saisissez un message...',
    send: 'Envoyer',
  },
  agentReview: {
    title: 'Vérifier et lancer',
    subtitle: 'Passez en revue vos paramètres avant de lancer votre assistant',
    launch: "Lancer l'assistant",
    launching: 'Lancement...',
    launched: "Lanc'é",
    launchError: "Erreur lors du lancement de l'assistant",
  },
  agentValidation: {
    nameRequired: 'Le nom est obligatoire',
    descriptionRequired: 'La description est obligatoire',
    languageRequired: 'La langue est obligatoire',
    timezoneRequired: 'Le fuseau horaire est obligatoire',
  },
  assistantFilters: {
    title: 'Filtres',
    clearAll: 'Effacer tout',
    apply: 'Appliquer',
    createdAt: 'Créé le',
    updatedAt: 'Mis à jour le',
    visibility: 'Visibilité',
    all: 'Tous',
    public: 'Public',
    private: 'Privé',
  },
  timezones: {
    search: 'Rechercher des fuseaux horaires...',
    noResults: 'Aucun fuseau horaire trouvé',
  },
  languages: {
    search: 'Rechercher des langues...',
    noResults: 'Aucune langue trouvée',
  },
  alerts: {
    successTitle: 'Succès',
    errorTitle: 'Erreur',
    warningTitle: 'Avertissement',
    infoTitle: 'Info',
  },
  validation: {
    required: 'Ce champ est obligatoire',
    invalidEmail: 'Adresse e-mail invalide',
    minLength: 'Longueur minimale {{count}} caractères',
    maxLength: 'Longueur maximale {{count}} caractères',
  },
  date: {
    today: "Aujourd'hui",
    yesterday: 'Hier',
    daysAgo: 'il y a {{count}} jours',
  },
  attachments: {
    dropFiles: 'Déposez des fichiers ici pour téléverser',
    browse: 'Parcourir',
    uploading: 'Téléversement...',
    upload: 'Téléverser',
    uploaded: 'Téléversé',
    uploadError: 'Erreur de téléversement',
    remove: 'Supprimer',
    removed: 'Supprimé',
    removeError: 'Erreur lors de la suppression',
  },
  prompts: {
    title: 'Prompts',
    subtitle: 'Gérez les modèles de prompts et les préréglages',
    create: 'Créer un prompt',
    edit: 'Modifier le prompt',
    delete: 'Supprimer le prompt',
    name: 'Nom',
    description: 'Description',
    content: 'Contenu',
    created: 'Prompt créé',
    updated: 'Prompt mis à jour',
    deleted: 'Prompt supprimé',
    creationError: 'Erreur lors de la création du prompt',
    updateError: 'Erreur lors de la mise à jour du prompt',
    deletionError: 'Erreur lors de la suppression du prompt',
    deleteConfirmTitle: 'Supprimer le prompt',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer ce prompt ?',
    deleteWarning: 'Cette action ne peut pas être annulée.',
  },
  promptEditor: {
    title: 'Éditeur de prompt',
    subtitle: 'Créez et modifiez vos prompts',
    save: 'Enregistrer le prompt',
    saved: 'Prompt enregistré',
    saveError: "Erreur lors de l'enregistrement du prompt",
    variables: 'Variables',
    addVariable: 'Ajouter une variable',
    variableName: 'Nom de la variable',
    variablePlaceholder: 'Entrez le nom de la variable',
    variableExample: 'Exemple : nom, contexte, date',
    removeVariable: 'Supprimer la variable',
  },
  promptPresets: {
    title: 'Préréglages de prompt',
    subtitle: 'Choisissez parmi des paramètres de prompt prédéfinis',
    systemPrompts: 'Prompts système',
    userPrompts: 'Prompts utilisateur',
    assistantPrompts: 'Prompts assistant',
    tone: 'Ton',
    tones: {
      professional: 'Professionnel',
      casual: 'Décontracté',
      friendly: 'Amical',
      formal: 'Formel',
    },
    style: 'Style',
    styles: {
      concise: 'Concise',
      detailed: 'Détaillé',
      persuasive: 'Persuasif',
      informative: 'Informatif',
    },
  },
  knowledge: {
    title: 'Sources de connaissance',
    subtitle: 'Gérez les sources de données pour vos assistants',
    addSource: 'Ajouter une source',
    searchSources: 'Rechercher des sources',
    sourceType: 'Type de source',
    sourceTypes: {
      document: 'Document',
      url: 'URL',
      database: 'Base de données',
    },
    status: 'Statut',
    statuses: {
      processing: 'En cours de traitement',
      ready: 'Prêt',
      failed: 'Échec',
    },
    lastUpdated: 'Dernière mise à jour',
    actions: 'Actions',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette source ?',
    deleteWarning: 'Cette action ne peut pas être annulée.',
  },
  knowledgeForm: {
    title: 'Ajouter une source de connaissance',
    sourceType: 'Type de source',
    name: 'Nom',
    description: 'Description',
    url: 'URL',
    file: 'Fichier',
    status: 'Statut',
    submit: 'Soumettre',
    submitting: 'Soumission...',
    submitted: 'Soumis',
    submitError: 'Erreur lors de la soumission de la source',
  },
  knowledgeStatus: {
    processing: 'En cours de traitement',
    ready: 'Prêt',
    failed: 'Échec',
  },
  behavior: {
    title: 'Comportement',
    systemPrompt: 'Prompt système',
    instructions: 'Instructions',
    temperature: 'Température',
    maxTokens: 'Nombre max de tokens',
    topP: 'Top P',
    frequencyPenalty: 'Pénalité de fréquence',
    presencePenalty: 'Pénalité de présence',
    save: 'Enregistrer',
    saved: 'Enregistré',
    saveError: "Erreur lors de l'enregistrement",
  },
  placeholders: {
    search: 'Rechercher...',
    enterText: 'Saisissez du texte...',
    enterName: 'Saisissez un nom...',
    enterDescription: 'Saisissez une description...',
  },
  roles: {
    owner: 'Propriétaire',
    admin: 'Admin',
    editor: 'Éditeur',
    viewer: 'Lecteur',
  },
  pagination: {
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    of: 'de',
  },
  emptyStates: {
    noData: 'Aucune donnée disponible',
    noResults: 'Aucun résultat',
    noAccess: 'Aucun accès',
  },
  filters: {
    apply: 'Appliquer',
    reset: 'Réinitialiser',
    clear: 'Effacer',
    sort: 'Trier',
    filter: 'Filtrer',
  },
  breadcrumbs: {
    home: 'Accueil',
    back: 'Retour',
  },
  tags: {
    addTag: 'Ajouter une étiquette',
    add: 'Ajouter',
    remove: 'Supprimer',
    required: 'Au moins une étiquette est requise',
    tagsHelp: 'Les étiquettes aident à organiser et catégoriser votre assistant',
    exampleQuestions: 'Questions exemples',
    exampleQuestionsHelp:
      'Ajoutez des questions exemples sur lesquelles les utilisateurs peuvent cliquer pour démarrer une conversation',
  },
  editAgent: {
    title: "Modifier l'assistant",
    subtitle: 'Modifiez les paramètres et le comportement de votre assistant IA',
    updateAgent: "Mettre à jour l'assistant",
    deleteAgent: "Supprimer l'assistant",
    updating: 'Mise à jour...',
    deleting: 'Suppression...',
    agentUpdated: 'Assistant mis à jour',
    updatedSuccessfully: 'a été mis à jour avec succès',
    updateError: 'Erreur de mise à jour',
    updateErrorDescription: "Une erreur s'est produite lors de la mise à jour de l'assistant. Veuillez réessayer.",
    agentDeleted: 'Assistant supprimé',
    deletedSuccessfully: 'a été supprimé avec succès',
    deleteError: 'Erreur de suppression',
    deleteErrorDescription: "Une erreur s'est produite lors de la suppression de l'assistant. Veuillez réessayer.",
    deleteConfirmTitle: "Supprimer l'assistant",
    deleteConfirmMessage:
      'Êtes-vous sûr de vouloir supprimer cet assistant ? Cette action ne peut pas être annulée.',
    confirmDelete: 'Oui, supprimer',
    loadingAgent: "Chargement des détails de l'assistant...",
    failedToLoad: "Échec du chargement des détails de l'assistant",
  },
  jobCategory: {
    addNew: 'Ajouter une catégorie',
    name: 'Nom',
    nameRequired: 'Le nom de catégorie est requis',
    enterName: 'Entrez le nom de la catégorie...',
    create: 'Créer',
    edit: 'Modifier',
    update: 'Mettre à jour',
    delete: 'Supprimer',
    created: 'Catégorie créée',
    createdSuccessfully: 'a été créée avec succès',
    updated: 'Catégorie mise à jour',
    updatedSuccessfully: 'a été mise à jour avec succès',
    deleted: 'Catégorie supprimée',
    deletedSuccessfully: 'a été supprimée avec succès',
    creationError: 'Erreur de création',
    creationErrorDescription: "Une erreur s'est produite lors de la création de la catégorie",
    updateError: 'Erreur de mise à jour',
    updateErrorDescription: "Une erreur s'est produite lors de la mise à jour de la catégorie",
    deletionError: 'Erreur de suppression',
    deletionErrorDescription: "Une erreur s'est produite lors de la suppression de la catégorie",
    deleteError: 'Erreur de suppression',
    deleteErrorDescription: "Une erreur s'est produite lors de la suppression de la catégorie",
    deleteConfirmTitle: 'Supprimer la catégorie',
    deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer "{{name}}" ?',
    deleteWarning: 'Cette action ne peut pas être annulée et peut affecter les assistants existants.',
    warning: 'Avertissement',
    agentsWillLoseCategory: 'les assistants perdront leur attribution de catégorie',
  },
  languageNames: {
    en: 'Anglais',
    nl: 'Néerlandais',
    de: 'Allemand',
    fr: 'Français',
    it: 'Italien',
    pl: 'Polonais',
  },
  iconSelector: {
    chooseIcon: 'Choisir une icône',
  },
}

const clientDefaults = {
  fallbackAgentDescription: "Assistant IA pour les connaissances entreprise d'AHV International.",
}

export default { ...frTranslation, ...clientDefaults }
